import { GetSmsGodoPoint } from 'ncp-api-supporter';
import { ActionContext } from 'vuex';

import { api } from '@/api';
import { RootState } from '@/store/root';

type MallPointState = {
  smsPointList: GetSmsGodoPoint[];
};

export default {
  namespaced: true,
  state: {
    smsPointList: [],
  },
  actions: {
    async fetchPoints({ commit }: ActionContext<MallPointState, RootState>) {
      const { data } = await api.getSmsGodoPoint();

      commit('SET_POINTS', data);
    },
  },
  mutations: {
    SET_POINTS(state: MallPointState, data: any) {
      state.smsPointList = data;
    },
  },
};
